import { css, theme } from '../lib';

export const list = css`
  font-family: ${theme.fonts.secondary};

  > * {
    margin-bottom: ${theme.space[2]};
  }
`;

export const listWithTitle = css`
  &:before {
    content: attr(aria-label);
    display: block;
    font-size: 1.25rem;
    font-weight: ${theme.fontWeights.heavy};
    margin-left: -16px;
    padding-bottom: ${theme.space.sp2};
  }
`;
